export const prodKeycloack = {
  "realm": "TWNTY",
  "url": "https://auth.twntydigital.de/auth/",
  "clientId": "signature"
}


export const API = 'https://sploger.de/api/v1/';
